export default __webpack_public_path__ + "static/media/icon-manager.6b81e270.svg";